import { SelectOption } from "@velaro/velaro-component-lib";
import { User } from "./../pages/Messaging/Users/types";
import React from "react";
export const UsersContext = React.createContext<{
  users: User[];
  setUsers: React.Dispatch<React.SetStateAction<User[]>>;
  fetchUsers: () => void;
  userOptions: SelectOption[];
  getDisplayNameForUser: (userId: number) => string;
  getUserByName: (name: string) => User | undefined;
}>({
  users: [],
  setUsers: () => {},
  fetchUsers: () => {},
  userOptions: [],
  getDisplayNameForUser: () => "Unknown User",
  getUserByName: () => undefined
});
